"use client";
import ErrorPage from '@/app/[locale]/error/page';

export default function Error({errors, status}) {
  return <ErrorPage errors={errors} status={status}/>;
};
